import React from 'react';
import { useRouteError, Link } from 'react-router-dom';

const ErrorPage = () => {
  const error = useRouteError();
  const isNotFound = error?.status === 404;

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-900 relative overflow-hidden font-inter">
      {/* Dynamic Background Elements */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-blue-500/20 blur-[120px] animate-pulse" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-purple-500/20 blur-[120px] animate-pulse" style={{ animationDelay: '1s' }} />
      <div className="absolute top-[20%] right-[10%] w-[20%] h-[20%] rounded-full bg-teal-500/20 blur-[100px] animate-pulse" style={{ animationDelay: '2s' }} />

      <div className="relative z-10 max-w-2xl w-full px-6 text-center">
        {/* Glassmorphic Container */}
        <div className="backdrop-blur-xl bg-white/5 border border-white/10 p-12 rounded-3xl shadow-2xl overflow-hidden relative">
          
          {/* Subtle top highlight for glassmorphism */}
          <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-white/30 to-transparent" />

          {isNotFound ? (
            <>
              <h1 className="text-8xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-br from-blue-400 via-teal-300 to-purple-400 mb-6 drop-shadow-sm">
                404
              </h1>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
                Lost in the Cloud
              </h2>
              <p className="text-lg text-slate-300 mb-10 max-w-lg mx-auto leading-relaxed">
                We couldn't find the page you were looking for. It might have been moved, deleted, or perhaps it never existed at all.
              </p>
            </>
          ) : (
            <>
              <div className="w-24 h-24 mx-auto mb-6 bg-red-500/20 rounded-full flex items-center justify-center">
                <svg className="w-12 h-12 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
                Unexpected Error
              </h2>
              <p className="text-lg text-slate-300 mb-6 max-w-lg mx-auto leading-relaxed">
                Something went wrong on our end. Please try again later.
              </p>
              {error?.statusText || error?.message ? (
                <div className="bg-black/30 rounded-xl p-4 mb-8 border border-white/5 inline-block text-left">
                  <code className="text-rose-300 text-sm font-mono">
                    {error.statusText || error.message}
                  </code>
                </div>
              ) : null}
            </>
          )}

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button 
              onClick={() => window.history.back()}
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl font-semibold text-white bg-white/5 hover:bg-white/10 border border-white/10 transition-all duration-200 cursor-pointer"
            >
              Go Back
            </button>
            <Link 
              to="/home" 
              className="w-full sm:w-auto px-8 py-3.5 rounded-xl font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 shadow-lg hover:shadow-blue-500/25 transition-all duration-200 border border-white/10"
            >
              Return Home
            </Link>
          </div>
        </div>
        
        <div className="mt-8 text-sm text-slate-500">
          DocLift &copy; {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
